import { render, staticRenderFns } from "./PaymentsRow.vue?vue&type=template&id=b97ffe62"
import script from "./PaymentsRow.vue?vue&type=script&lang=js"
export * from "./PaymentsRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports